(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["landell-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-landell-collection]:not([data-initialized])').forEach((root) => {
    root.dataset.initialized = 'true';
    const cards = [...root.querySelectorAll('[data-product-card]')];
    const grid = root.querySelector('[data-product-grid]');
    const status = root.querySelector('[data-status]');
    const sizeSelect = root.querySelector('[data-size-filter]');
    const sortSelect = root.querySelector('[data-sort]');
    const state = { type: 'all', audience: 'all', size: 'all', sort: 'featured' };
    const sizeAliases = {
      s: ['s', 'small', 'ys', 'youth s', 'youth small', 'as', 'adult s', 'adult small'],
      m: ['m', 'medium', 'ym', 'youth m', 'youth medium', 'am', 'adult m', 'adult medium'],
      l: ['l', 'large', 'yl', 'youth l', 'youth large', 'al', 'adult l', 'adult large'],
      xl: ['xl', 'x-large', 'extra large', 'yxl', 'youth xl', 'axl', 'adult xl']
    };

    const apply = () => {
      const visible = cards.filter((card) => {
        const typeMatch = state.type === 'all' || card.dataset.type === state.type;
        const audienceMatch = state.audience === 'all' || card.dataset.audience.split(' ').includes(state.audience);
        const sizes = card.dataset.sizes.split('|').map((value) => value.trim()).filter(Boolean);
        const sizeMatch = state.size === 'all' || sizes.length === 0 || sizeAliases[state.size].some((alias) => sizes.includes(alias));
        const show = typeMatch && audienceMatch && sizeMatch;
        card.hidden = !show;
        return show;
      });

      const sorted = [...visible].sort((a, b) => {
        if (state.sort === 'price-low') return Number(a.dataset.price) - Number(b.dataset.price);
        if (state.sort === 'price-high') return Number(b.dataset.price) - Number(a.dataset.price);
        if (state.sort === 'name') return a.dataset.title.localeCompare(b.dataset.title);
        return Number(a.dataset.order) - Number(b.dataset.order);
      });
      sorted.forEach((card) => grid.append(card));
      status.textContent = `${visible.length} items${state.size === 'all' ? '' : ` available in ${state.size.toUpperCase()}`}`;
    };

    const setType = (value, scroll = false) => {
      state.type = value;
      root.querySelectorAll('[data-filter-kind="type"]').forEach((button) => button.classList.toggle('is-active', button.dataset.filterValue === value));
      apply();
      if (scroll) root.querySelector('[data-products]').scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    root.querySelectorAll('[data-category-filter]').forEach((button) => button.addEventListener('click', () => setType(button.dataset.categoryFilter, true)));
    root.querySelectorAll('[data-filter-kind]').forEach((button) => button.addEventListener('click', () => {
      const kind = button.dataset.filterKind;
      const value = button.dataset.filterValue;
      if (kind === 'type') {
        setType(value);
      } else {
        state.audience = state.audience === value ? 'all' : value;
        root.querySelectorAll('[data-filter-kind="audience"]').forEach((item) => item.classList.toggle('is-active', item.dataset.filterValue === state.audience));
        apply();
      }
    }));
    sizeSelect.addEventListener('change', () => { state.size = sizeSelect.value; apply(); });
    sortSelect.addEventListener('change', () => { state.sort = sortSelect.value; apply(); });
    apply();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
